module.exports = __webpack_public_path__ + "resources/img/img_turple.90dc5d7cf87979af3a6c447da20cf1e0.png";